

























































































































































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ListUtils from '@/lib/listUtils';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import WorkerDto from '@/models/Workers/WorkerDto';
import DateTimeUtils from '@/lib/dateTimeUtils';
import UpdateWorkerGeneralDetailsRequest from '@/models/Workers/UpdateWorkerGeneralDetailsRequest';
import ComplianceDocuments from '../Documents/ComplianceDocuments.vue';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import BranchDto from '@/models/Branches/BranchDto';

@Component({
  components: { ComplianceDocuments },
    name: 'WorkerGeneralDetailsEdit'
})
export default class extends GiganautVueDialog {
 
  public dialog = false;
  public datePicker = false;
  public worker = new WorkerDto();
  public dateOfBirth = '';
  
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.worker = JSON.parse(JSON.stringify(WorkerDetailsModule.currentWorker));
      if (this.worker.dateOfBirth !== null) {
        this.dateOfBirth = new Date(this.worker.dateOfBirth).toISOString().substr(0, 10)
      } 
      //Need to copy the default branch from the branch list if there is one
      //so that the desks are populated correctly 
      if (this.worker.defaultBranch) {
        this.worker.defaultBranch = this.branches.find((findBranch: BranchDto) => findBranch.id === this.worker.defaultBranch.id);
      } 
    }
  }

  @Watch('worker.defaultBranch')
  onDefaultBranchChanged(val: BranchDto, oldVal: BranchDto) {
    if (!val) {
      this.worker.defaultDeskId = undefined;
      this.worker.defaultDesk = undefined;
    }
  }

  get desks() {
    if (this.worker.defaultBranch) {
      return this.worker.defaultBranch.desks;
    }
    return [];
  }

  get branches() {
      return AgencySettingsModule.branches;
  }

  get loading() {
    return WorkerDetailsModule.loadingDialog;
  }

  get genders() {
    return ListUtils.genders();
  }

  get workTypeOptions() {
    return ListUtils.workTypes();
  }

  @Watch("datePicker")
  datePickerChanged(val: boolean) {
        val && setTimeout(() => ((this.$refs.picker as any).activePicker = 'YEAR'))
    }

  get maritalStatuses() {
    return ListUtils.maritalStatuses();
  }

  get nationalities() {
    return ListUtils.nationalities();
  }

  async saveDOB(date: any) {
    (this.$refs.datePicker as any).save(date)
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }

    const request = new UpdateWorkerGeneralDetailsRequest();
    request.updatedAt = this.worker.updatedAt;
    request.legacyId = this.worker.legacyId;
    request.emailAddress = this.worker.emailAddress;
    request.mobilePhoneNumber = this.worker.mobilePhoneNumber;
    request.otherPhoneNumber = this.worker.otherPhoneNumber;
    request.nationality = this.worker.nationality;
    request.dateOfBirth = this.dateOfBirth;
    request.gender = this.worker.gender;
    request.maritalStatus = this.worker.maritalStatus;
    request.workTypes = this.worker.workTypes;
    request.isDriver = this.worker.isDriver;
    request.isAgreedToMarketing = this.worker.isAgreedToMarketing;
    if (this.worker.defaultBranch) {
      request.defaultBranchId = this.worker.defaultBranch.id;   
    }
    if (this.worker.defaultDesk) {
      request.defaultDeskId = this.worker.defaultDesk.id;
    }

    await WorkerDetailsModule.editGeneralDetails(request)
    this.dialog = false;
  }


  
}
